// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"4":"2712f258","474":"c79806a0","520":"d2c90ada","673":"4a39dd0c","913":"b9825106","935":"2427d9e9"}[chunkId] + ".css";
};